import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'GROUP'

export type GroupState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function groupReducer(state: GroupState = initialState, action: AnyAction): GroupState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
